// ===========================================
// School Home Button
// ===========================================
// The "Return Home" button on a school's public pages (Meet & Greet booking
// and verification, registration, enquiry). It goes to the SCHOOL's public
// profile page (`/<school-slug>`), never the Music 'n Me product homepage:
// a family arriving through a school should land back on that school
// (Andrew, 2026-09-28).
//
// Reads TenantContext softly (useContext, not the throwing useTenant) so it
// still renders outside a TenantProvider; the slug then falls back to the
// route param, and with no school at all it degrades to "/".

import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, ButtonProps } from '@mui/material';
import { TenantContext } from '../../contexts/TenantContext';

type SchoolHomeButtonProps = Omit<ButtonProps, 'onClick' | 'children'>;

export default function SchoolHomeButton({ variant = 'contained', ...rest }: SchoolHomeButtonProps) {
  const navigate = useNavigate();
  const tenant = useContext(TenantContext);
  const params = useParams<{ schoolSlug?: string }>();

  const slug = tenant?.schoolSlug || params.schoolSlug || null;
  const schoolName = tenant?.school?.name;

  return (
    <Button variant={variant} onClick={() => navigate(slug ? `/${slug}` : '/')} {...rest}>
      {schoolName ? `Back to ${schoolName}` : 'Return Home'}
    </Button>
  );
}
